import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { McoInvFileList } from '../mcoInvFile/McoInvFileList';
import { McoInvRbtLedgerPymtList } from '../mcoInvRbtLedgerPymt/McoInvRbtLedgerPymtList';
import { McoInvLineList } from '../mcoInvLine/McoInvLineList';
import { McoInvLifecycleButton } from './McoInvLifecycleButton';

export const McoInvDetail = () => {
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'invLines', label: 'Lines', content: <McoInvLineList mcoInv={entityObj} /> },
    { id: 'mcoInvRbtLedgerPymt', label: 'Ledgers & Payments', content: <McoInvRbtLedgerPymtList mcoInvId={entityObj.id} /> },
    { id: 'mcoInvFiles', label: 'Managed Care Invoice Files', content: <McoInvFileList mcoInvId={entityObj.id} /> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="MCO_INV" parentEntityId={entityObj.id} /> },
  ];

  const augButtons = (buttons) => {
    buttons.push(<McoInvLifecycleButton key="lifecycleButton" selectedEntities={[entityObj]} />);
  };

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
